import { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'

const COUNT_DURATION_SECONDS = 0.9

const prefersReducedMotion = (): boolean =>
  typeof window.matchMedia !== 'function' ||
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

/** Counts up from 0 to the target, and from the current number whenever the target moves. */
export const useAnimatedCount = (target: number): number => {
  const [shown, setShown] = useState(0)
  const tracker = useRef({ value: 0 })

  useEffect(() => {
    if (prefersReducedMotion()) {
      tracker.current.value = target
      setShown(target)
      return undefined
    }

    const tween = gsap.to(tracker.current, {
      value: target,
      duration: COUNT_DURATION_SECONDS,
      ease: 'power2.out',
      onUpdate: () => setShown(Math.round(tracker.current.value)),
    })
    return () => {
      tween.kill()
    }
  }, [target])

  return shown
}
